import React, { Component } from 'react'
import Markdown from 'features/Markdown'
import { Row, Col } from 'components/Layout'
import s from './MultiTextParagraphs.scss'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import { CmsIcon } from 'features/Cms/CmsIcon'

const TextItem = ({ text, title, icon }) => (
  <div className={s.outer}>
    <div className={cn(s.title, sLay['layout-row'], sLay['layout-align-start-center'])}>
      {icon && <CmsIcon name={icon} size="30" style={{ marginRight: '10px' }} />}
      <h4 className={sLay.flex}>{title}</h4>
    </div>
    <Markdown className={s.body} text={text} />
  </div>
)

export default class MultiTextParagraphs extends Component {
  render() {
    const { data, columns = 2 } = this.props
    const dataFiltered = data.filter(item => item.title)

    return (
      <Row className={cn(sLay['layout-gt-xs-row'], sLay['layout-xs-column'], sLay['layout-wrap'])}>
        {dataFiltered.map(({ title, text, icon }, idx) => (
          <Col className={cn(sLay[`flex-gt-xs-${Math.floor(100 / columns)}`])} key={idx}>
            <TextItem title={title} text={text} icon={icon} />
          </Col>
        ))}
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/MultiText/MultiTextParagraphs/MultiTextParagraphs.jsx